<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'create_broker_account5',params:{'id':this.$route.params.id}}" :class="[{'disabled' : !isAlreadyDone()}]">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('mannual_proof.text3')}}<span class="bgTitle">{{$t('mannual_proof.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12 col-md-10 mb-2">
                <h4 class="mb-2">{{$t('mannual_proof.text5')}}</h4>
                <p>{{$t('mannual_proof.text6')}}</p>
            </div>
            <div class="col-12 mb-2">
                <h4 class="mb-3">{{$t('mannual_proof.text7')}}</h4>
                <ul class="boxRadio selectIdenty d-flex align-items-center flex-wrap mb-4">
                    <li v-for="value,key in documentsList" :key="key">
                        <label class="customCheckBox radio mb-0">
                            <img class="mb-1 document" height="50" :src="`${static_vars.imagePath}/assets/images/passport.svg`" :alt="key"
                                :title="value" />
                            <span class="name medium f-15">{{value}}</span>
                            <input type="radio" name="radio" :id="'document'+key" v-model="documentType" :value="key" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ul>
            </div>
            <div class="col-12 mb-2">
                <h4 class="mb-2">{{$t('mannual_proof.text8')}}</h4>
                <p class="mb-0">{{$t('mannual_proof.text9')}}</p>
                <p>{{$t('mannual_proof.text10')}}</p>
                <ul class="d-flex align-items-center pt-2 mb-4">
                    <li class="me-3"><img :src="`${static_vars.imagePath}/assets/images/good.png`" :alt="$t('mannual_proof.text14')" :title="$t('mannual_proof.text14')" /> </li>
                    <li class="me-3"><img :src="`${static_vars.imagePath}/assets/images/bad-s.png`" :alt="$t('mannual_proof.text15')" :title="$t('mannual_proof.text15')" /> </li>
                    <li><img :src="`${static_vars.imagePath}/assets/images/bad.png`" :alt="$t('mannual_proof.text14')" :title="$t('mannual_proof.text14')" /> </li>
                </ul>
            </div>
            <div class="col-12 col-md-7 mb-3">
                <h4 class="mb-2" >{{$t('mannual_proof.text11')}}</h4>
                <div class="upload-btn-wrapper">
                    <div class="beforeUplod flex-column justify-content-center align-items-center" :class="(!file.name) ? 'd-flex' : 'd-none'">
                        <img :src="`${static_vars.imagePath}/assets/images/upload.svg`" :alt="$t('mannual_proof.text16')" :title="$t('mannual_proof.text16')" />
                        <button class="btn">{{$t('mannual_proof.text11')}}</button>
                        <input type="file" name="myfile" id="fileUpload" ref="document" @change="setImage($event)"  />
                    </div>
                    <div class="afterUplod d-flex flex-column justify-content-center align-items-center p-3" v-if="file.name">
                        <img :src="`${static_vars.imagePath}/assets/images/uploaded.svg`" :alt="$t('mannual_proof.text16')" :title="$t('mannual_proof.text16')" />
                        <button class="btn">{{$t('mannual_proof.text12')}}</button> 
                        <div class="position-relative d-flex align-items-center">
                            <p class="f-12 mb-0">{{file.name}} </p>
                            <a href="javascript:void(0)" class="delete" @click="clearDoc()"><vue-feather size="14" type="trash-2"></vue-feather></a>
                        </div>
                       <!--  <input type="file" name="myfile"  /> -->
                    </div>
                    <div class="progress" v-if="file.name">
                        <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <a href="javascript:void(0);" class="grd_btn full_size" :class="[{'disabled' : (!file.name || !documentType)}]" @click="submit()">{{$t('mannual_proof.text13')}}
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import { useMainStore } from "@/store";
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
           file : {},
           documentType : 'CREDIT_CARD',
           documentsList : {
            'CREDIT_CARD' : 'Bank/Credit Card Statement',
            'UTILITY_BILL' : 'Utility Bill',
            'PAYROLL' : 'Payroll Statement',
            'TAX_DOCUMENT' : 'Tax Document'
            }
        }
    },
    methods:{
        isAlreadyDone(){
            if(Object.keys(this.store.brokerStatusList).length && this.store.brokerStatusList.stepsStatus && this.store.brokerStatusList.stepsStatus.length){
                this.store.brokerStatusList.stepsStatus.forEach(val => {
                    if(val.step == 'Declaration' && val.completed){
                        return false
                    }else{
                        return true
                    }
                })
            }else{
                return true
            }
        },
        setImage(event){
            this.file = event.target.files[0]
        },
        clearDoc(){
            document.getElementById("fileUpload").value = ''
            this.file = {}
        },
        submit(){
            let formData = new FormData();
            if(this.file.name){
                formData.append('document',this.file)
            }
            formData.append('documentType','PROOF_OF_RESIDENCE')
            formData.append('documentSubType',this.documentType)
            formData.append('documentSide','FRONT_SIDE')
            this.store.saveBrokerPORDocument(formData,true,this.$route.params.id)
        }
    }
}
</script>